import request from '@/utils/request'

const sharedApi = process.env.VUE_APP_SHARED_API

// 根据业务fileId获取文件（只有一个附件，如企业logo，用户头像场景）
export function getFileUrlByFileIdApi(params) {
  return request(
    {
      url: sharedApi + `/attachments/${params.attachmentId}/access-url`,
      method: 'get'
    },
    { needLoading: false }
  )
}
